// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const originalOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (message?.toString().includes('Timeout')) return true;
  return originalOnError?.(message, source, lineno, colno, error);
};

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('Timeout') || e.reason?.toString().includes('Timeout')) {
    e.preventDefault();
    e.stopPropagation();
  }
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
